import Alert from '@mui/material/Alert'
import AlertTitle from '@mui/material/AlertTitle'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'

import { FormattedMessage } from 'react-intl'
import testidKeys from '../../../app/testidKeys'

const AlertNoPayment = ({ licensePlate }: { licensePlate: string }) => {
  return (
    <Alert
      severity="info"
      sx={{ textAlign: 'left' }}
      data-testid={testidKeys.STEP_LICENSE_PLATE_NO_INVOICES_INFORMATION}
    >
      <AlertTitle>
        <FormattedMessage
          id="page.webPayment.stepFillLicensePlate.alert.title.noUnpaidParkingEvents"
          values={{ licensePlate }}
        />
      </AlertTitle>
      <FormattedMessage id="page.webPayment.stepFillLicensePlate.alert.body.reason" />
      <List
        sx={{
          paddingLeft: 2,
          listStyleType: 'disc',
        }}
      >
        {[1, 2, 3].map((i) => (
          <ListItem
            sx={{ display: 'list-item' }}
            key={`noUnpaidParkingEventsDescriptionItem-${i}`}
          >
            <FormattedMessage
              id={`page.webPayment.stepFillLicensePlate.alert.body.desc${i}`}
            />
          </ListItem>
        ))}
      </List>
    </Alert>
  )
}

export default AlertNoPayment
